var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{class:_vm.$route.path.includes('login') ? '' : 'middle-container'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }